

export enum MessageFromAddInType {
  // Message received from the add-in iframe when the JWT token is expired, if in web context
  TOKEN_EXPIRED = "tokenExpired",
  CHART_CREATED = "chartCreated",
  GO_TO_SUBSCRIPTION = "goToSubscription",
}

type MessageHandler = (event: MessageEvent) => void;

// Function to subscribe to a specific message type from the add-in
// Returns a function to unsubscribe from the message type
export function subscribeToMessageType(
  type: MessageFromAddInType,
  handler: MessageHandler,
): () => void {
  const listener = (event: MessageEvent) => {
    if (
      (!event.origin.includes(import.meta.env.ADMIN_ADD_IN_URL) &&
        !import.meta.env.ADMIN_ADD_IN_URL.includes(event.origin)) ||
      event.data?.type !== type
    ) {
      return;
    }
    handler(event);
  };
  window.addEventListener("message", listener);
  // Return unsubscribe function
  return () => window.removeEventListener("message", listener);
}